export const LISTING_PHOTO_MOSAIC_GRID_SIZE = 4

export const LISTING_PHOTO_MOSAIC_CELL_TYPE = {
  add: 'add',
  empty: 'empty',
  photo: 'photo',
}

export const LISTING_PHOTO_MOSAIC_ADD_CELL_ID = 'add'

export const LISTING_PHOTO_MOSAIC_EMPTY_CELL_ID = 'empty'

export const LISTING_PHOTO_MOSAIC_SKELETON_CELLS = [1, 2, 3, 4]

export const QA_NAME_LISTING_PHOTO_MOSAIC = 'listingPhotoMosaic'

export const QA_NAME_LISTING_PHOTO_MOSAIC_LEAD = 'listingPhotoMosaicLead'

export const QA_NAME_LISTING_PHOTO_MOSAIC_TILE = 'listingPhotoMosaicTile'

export const QA_NAME_LISTING_PHOTO_MOSAIC_MORE = 'listingPhotoMosaicMore'

export const QA_NAME_LISTING_PHOTO_MOSAIC_ADD = 'listingPhotoMosaicAdd'

export const QA_NAME_LISTING_PHOTO_MOSAIC_EMPTY_STATE =
  'listingPhotoMosaicEmptyState'

export const QA_NAME_LISTING_PHOTO_MOSAIC_SKELETON =
  'listingPhotoMosaicSkeleton'
